import React, { useEffect } from "react";
import StyledRetailGuidelines from "./styles";
import Welcome from "../../components/Welcome";
import CardSection from "../../components/CardSection";

export default function RetailGuidelines({
  loggedIn,
  setLoggedIn,
  siteContent,
  siteImages,
}) {
  // useEffect(() => {
  //   if (loggedIn) window.scrollTo({ top: 0 });
  // }, [loggedIn]);
  return (
    <StyledRetailGuidelines>
      <Welcome
        textContent={siteContent?.welcome}
        imageContent={siteImages?.welcome}
      />
      { siteContent?.cardSection && siteImages?.cardSection ? (
        <CardSection
        loggedIn={loggedIn}
        setLoggedIn={setLoggedIn}
          textContent={siteContent?.cardSection}
          imageContent={siteImages?.cardSection}
        />
      ) : null}
    </StyledRetailGuidelines>
  );
}
